import { Alert } from 'antd';
import React from 'react';
export default class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, errorInfo: null, time: 5 };
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    window.setInterval(
      () =>
        this.setState({
          time: this.state.time - 1
        }),
      1000
    );
  }

  static getDerivedStateFromError(error: any) {
    return { error: true, errorInfo: error };
  }

  render() {
    if(this.state.time === 0) location.reload();
    if (this.state.errorInfo) {
      return (
        <>
          <Alert
            message="Something went wrong."
            description={this.state.errorInfo.componentStack}
            type="error"
            showIcon
          />
          <Alert
            message="Warning"
            description={`This page will reload in ${this.state.time} seconds`}
            type="warning"
            showIcon
          />
        </>
      );
    }
    return this.props.children;
  }
}
